import { jsxs as f, jsx as t } from "react/jsx-runtime";
import { _ as e } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import u from "../Portal/index.js";
import h from "../../hooks/useFloatPlacement.js";
import '../../index47.css';const v = "_popup_1o2gn_1", g = "_top-orientation_1o2gn_9", N = "_pointer_1o2gn_15", x = "_icon_1o2gn_25", o = {
  popup: v,
  topOrientation: g,
  pointer: N,
  icon: x
};
function w(i) {
  const {
    parentRef: r,
    elementRef: p,
    children: s,
    className: a,
    pointerClassName: c,
    preferredWidth: l
  } = i, {
    content: m,
    pointer: _,
    width: d,
    orientation: n
  } = h(r, l);
  return /* @__PURE__ */ f(u, { children: [
    /* @__PURE__ */ t(
      "div",
      {
        ref: p,
        style: {
          ...m,
          width: d
        },
        className: e(
          o.popup,
          n.vertical === "bottom" && o.topOrientation,
          a
        ),
        children: s
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        className: e(
          o.pointer,
          n.vertical === "bottom" && o.topOrientation,
          c
        ),
        style: { ..._ },
        children: /* @__PURE__ */ t(
          "svg",
          {
            className: o.icon,
            viewBox: "0 0 200 100",
            children: /* @__PURE__ */ t(
              "path",
              {
                d: "M0 100 L100 0 L200 100Z"
              }
            )
          }
        )
      }
    )
  ] });
}
export {
  w as default
};
